import type { IconNode } from '../types';

/**
 * @name bag-hand
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCA4YzAtMi44IDEuOC01IDQtNXM0IDIuMiA0IDUiIC8+CiAgPHBhdGggZD0ibTIxIDE4LjYtMi05LjhjLS4xLS41LS41LS44LTEtLjhINmMtLjUgMC0uOS4zLTEgLjhsLTIgOS44di40YTIgMiAwIDAgMCAyIDJoMTRhMiAyIDAgMCAwIDItMloiIC8+CiAgPHBhdGggZD0iTTEyIDEydjQiIC8+CiAgPHBhdGggZD0iTTE4IDhBNiA2IDAgMCAxIDYgOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/bag-hand
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bagHand: IconNode = [
  ['path', { d: 'M8 8c0-2.8 1.8-5 4-5s4 2.2 4 5', key: '1m6jzl' }],
  [
    'path',
    {
      d: 'm21 18.6-2-9.8c-.1-.5-.5-.8-1-.8H6c-.5 0-.9.3-1 .8l-2 9.8v.4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2Z',
      key: 'l462o9',
    },
  ],
  ['path', { d: 'M12 12v4', key: 'tww15h' }],
  ['path', { d: 'M18 8A6 6 0 0 1 6 8', key: 'pqao60' }],
];

export default bagHand;
